import React from 'react';
import EngagedList from '@features/eventDetail/components/EngagedList';
import EventHeader from '@features/eventDetail/components/EventHeader';

const EventEngagedTemplate = () => (
  <>
    <EventHeader />
    <EngagedList />
  </>
);

export default EventEngagedTemplate;
